/**
 * Represents the status of the external flow
 */
const ExternalFlowStatusEnum = {
  /**
   * Initial status when the external flow gets created
   */
  Initial: 1, //white
  /**
   * In this status the external flow is temporary blocked by a content validation operation
   */
  ContentValidation: 2, //grey
  /**
   * In this status the content of the ZIP is valid
   */
  ContentValid: 3, //green
  /**
   * In this status the content of the ZIP is not valid
   */
  ContentNotValid: 4, //red
  /**
   * In this status the external flow is temporary blocked by a signature validation operation if a ZIP with a signed PDFs is available
   */
  SignValidation: 5, //grey
  /**
   * In this status all PDF files are with a signature in the ZIP
   */
  SignValid: 6, //green
  /**
   * In this status there is at list one PDF file with a missing signature in the ZIP
   */
  SignNotValid: 7, //red
  /**
   * The flow is ready to be send
   */
  ReadyToSend: 8, //green
  /**
   * This status is indication that the flow has been successfully sent
   */
  Sent: 9,
  /**
   * This status is indication that the flow has not been sent because of some issues
   */
  NotSent: 10, //red
};

export default ExternalFlowStatusEnum;
